import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms'

export function domainEmailValidator(privateStore: boolean, domain?: string): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const emailValue = control.value?.trim().toLowerCase()

    // If there's no email entered, or if store is not private,
    // or if there's no domain specified, pass validation
    if (!emailValue || !privateStore || !domain) {
      return null
    }

    // Check the domain requirement
    if (!emailValue.endsWith(`@${domain.toLowerCase()}`)) {
      return { invalidDomain: true }
    }

    return null
  }
}
